import { Injectable } from '@angular/core';
import { SdkInsight } from 'app/models/SdkInsight';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SdkInsightStateService {
  private sdkSubject = new BehaviorSubject<SdkInsight | null>(null);

  sdk$ = this.sdkSubject.asObservable();

  setSdkInsight(sdk: SdkInsight) {
    this.sdkSubject.next(sdk);
  }
  getSdkInsight(): SdkInsight | null {
    return this.sdkSubject.getValue();
  }
}
